<template>
  <div class="intent_wrapper">
    <div class="title">출제포인트 생성</div>
    <b-container class="contzone">
      <b-row>
        <b-col sm="2" class="sub">구분</b-col>
        <b-col>
          <b-form-radio-group
            v-model="intent_typeX"
            :options="intent_type1_field"
            class="mb-3"
            value-field="value"
            text-field="text"
            disabled-field="notEnabled"
          ></b-form-radio-group>
        </b-col>
      </b-row>
      <b-row class="item">
        <b-col sm="2" class="sub">대분류(D1)</b-col>
        <b-col>
          <b-input v-model="gbn1X"></b-input>
        </b-col>
      </b-row>
      <b-row class="item">
        <b-col sm="2" class="sub">중분류(D2)</b-col>
        <b-col>
          <b-input v-model="gbn2X"></b-input>
        </b-col>
      </b-row>
      <b-row class="item">
        <b-col sm="2" class="sub">소분류(D3)</b-col>
        <b-col>
          <b-input v-model="gbn3X"></b-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="buttons">
          <b-button variant="primary" @click="save">저장</b-button>
          <b-button @click="cancel">취소</b-button>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
export default {
  computed: {
    ...mapState("intentStore", ["gbn1", "gbn2", "gbn3", "intent_type"]),
    intent_typeX: {
      set(val) {
        this.$store.commit("intentStore/updateIntentType", val);
      },
      get() {
        return this.intent_type;
      },
    },
    gbn1X: {
      set(val) {
        // this.gbn1 = val;
        this.$store.commit("intentStore/updateGbn1", val);
      },
      get() {
        return this.gbn1;
      },
    },
    gbn2X: {
      set(val) {
        this.$store.commit("intentStore/updateGbn2", val);
      },
      get() {
        return this.gbn2;
      },
    },
    gbn3X: {
      set(val) {
        this.$store.commit("intentStore/updateGbn3", val);
      },
      get() {
        return this.gbn3;
      },
    },
    intent_type1_field() {
      return [
        { value: 1, text: "문장훈련형" },
        { value: 2, text: "문풀훈련형" },
      ];
    },
    intent_field() {
      return this.$store.state.intent_field;
    },
  },

  methods: {
    ...mapActions("intentStore", ["saveIntent"]),
    save() {
      // this.$store.dispatch("saveIntent");
      alert();
      // this.saveIntent();
    },
    cancel() {
      alert("cancel");
    },
  },
};
</script>


<style lang="scss" scoped>
@import "@/styles/_variables.scss";
.intent_wrapper {
  background-color: white;
  border-radius: 5px;
  box-shadow: 3px 3px 3px $gray400;

  margin: 20px;
  padding: 20px;
  .title {
    font-size: 1.2em;
    color: $gray50;
    background-color: $gray600;
    border-radius: 4px;
    padding-bottom: 6px;
  }
  .title::before {
    content: "";
    font-size: 1.5em;
    padding-left: 6px;
    color: $gray50;
  }
  .sub {
    text-align: right;
  }

  .item {
    margin: 10px;
  }

  .buttons {
    text-align: center;
    button {
      margin-right: 4px;
    }
  }

  .contzone {
    margin-top: 15px;
  }
}
</style>